import {Checkbox, FormControlLabel, Typography, withStyles} from '@material-ui/core';
import * as React from "react";
import {IFamilyData, IFamilyMember} from '@app-types/websocket/family.types';
import TranslateNew from '@translate/TranslateNew';
import {connect} from "react-redux";
import Button from "@components/common/button/Button";
import * as EventActions from '@services/events/event.action';
import * as UserActions from '@services/user/user.actions';
import {IUser} from "@app-types/api/user.types";
import {WithStyles} from "@material-ui/core/styles";
import ProgressBar from "@components/common/progressBar/progressBar";
import cordovaContext from "../../../../cordovaContext";
import Input from "@components/common/input/input.component";
import {ImportHolidaysStyles} from "@components/onboarding/steps/StepImportHolidays/importHolidays.styles";
import { AI_TASK_TYPE, IAiTask } from '@app-types/websocket/event.types';
import { CountryType } from '@components/calendar2/holidays/holidayTypes';
import { getHolidayCountryForSchoolVacation, getSchoolVacationCountryOptions, normalizeSchoolVacationCountry } from '@components/calendar2/holidays/schoolVacationCountries';
import {
    getDefaultSchoolVacationAccountIds,
    getSchoolVacationChildren,
    getSubmittedSchoolVacationAccountIds,
    schoolVacationChildrenKey,
} from '@components/calendar2/holidays/schoolVacationChildren';


const tn: TranslateNew = TranslateNew.getInstance();

interface IImportHolidaysProps extends WithStyles<typeof ImportHolidaysStyles> {
    nextStep: (customStep?: number) => void;
    progress?: number | undefined;
    family: IFamilyMember[];
    familyData? : IFamilyData;
    user: IUser;
    aiTask: (task:IAiTask) => void;
    selectedCountry:string;
    setCountry: (country: CountryType) => void;
    setRegion: (region: string) => void;
}

interface IImportHolidaysState {
    schoolName:string;
    schoolLocation: string;
    country:string;
    accountIds:number[];
}

class ImportHolidays extends React.Component<IImportHolidaysProps, IImportHolidaysState> {

    constructor(props: IImportHolidaysProps) {
        super(props);

        console.log(props.selectedCountry);

        this.state = {
            schoolName:"",
            schoolLocation:"",
            country:normalizeSchoolVacationCountry(props.selectedCountry),
            accountIds:getDefaultSchoolVacationAccountIds(props.family),
        };
    }

    public componentDidUpdate(previousProps: IImportHolidaysProps) {
        if (schoolVacationChildrenKey(previousProps.family) !== schoolVacationChildrenKey(this.props.family)) {
            this.setState({accountIds:getDefaultSchoolVacationAccountIds(this.props.family)});
        }
    }

    public render() {
        const {classes: style} = this.props;
        const {schoolName, schoolLocation} = this.state;
        const children = getSchoolVacationChildren(this.props.family);
        const submittedAccountIds = getSubmittedSchoolVacationAccountIds(this.props.family, this.state.accountIds);

        return (<div className={style.root}>
            <div className={style.background}>
                <div className={style.circle}/>
            </div>
            <div className={style.container}>
                {this.props.progress && (<div className={style.topBar}>
                    <ProgressBar value={this.props.progress}/>
                </div>)}
                <div className={style.topContent}>
                    <Typography variant="h2">{tn.lang.importWeekendsFor}</Typography>
                    <Typography>
                        {tn.lang.importDaysOffFor}
                    </Typography>
                </div>
                <div className={style.form} >
                    <Input
                        id="schoolName"
                        name="schoolName"
                        type="text"
                        onChange={(e) => this.setState({schoolName:e.target.value})}
                        value={schoolName}
                        placeholder={tn.lang.importSchoolExample}
                        label={tn.lang.importSchool}
                    />
                    <Input
                        id="schoolLocation"
                        name="schoolLocation"
                        type="text"
                        onChange={(e) => this.setState({schoolLocation:e.target.value})}
                        value={schoolLocation}
                        placeholder={tn.lang.importSchoolregionExample}
                        label={tn.lang.importSchoolRegion}
                    />
                    <label htmlFor={"schoolCountry"} className={this.props.classes.labelWrapper}>
                        <Typography className={this.props.classes.labelText}>{tn.lang.importSchoolCountry} </Typography>
                        <select
                            id="schoolCountry"
                            className={this.props.classes.selectStyle}
                            value = {this.state.country}
                            onChange = {(e) => this.setState({country:e.target.value})}
                        >
                            {getSchoolVacationCountryOptions().map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </label>
                    {children.length > 1 && <div
                        className={this.props.classes.labelWrapper}
                        role="group"
                        aria-label={tn.lang.importSchoolChildren}
                    >
                        <Typography className={this.props.classes.labelText}>{tn.lang.importSchoolChildren}</Typography>
                        <div className={this.props.classes.childOptions}>
                            {children.map((child) => <FormControlLabel
                                className={this.props.classes.childOption}
                                key={child.id}
                                control={<Checkbox
                                    color="primary"
                                    checked={this.state.accountIds.includes(child.id)}
                                    onChange={() => this.toggleAccountId(child.id)}
                                />}
                                label={child.firstName}
                            />)}
                        </div>
                    </div>}

                </div>
                <div className={style.formBottomContent}>
                    <Button
                        disabled={this.state.schoolLocation.trim().length < 2
                            || this.state.schoolName.trim().length < 2
                            || submittedAccountIds.length === 0}
                        onClick={() => this.handleSubmit()}
                        variant='contained'
                        color='primary'
                        size="large"
                        fullWidth={true}
                    >
                        {tn.lang.continue}
                    </Button>
                    <Button
                        onClick={() => this.props.nextStep()}
                        fullWidth={true}
                    >
                        {tn.lang.skip}
                    </Button>
                </div>
            </div>
        </div>);
    }


    private handleSubmit = () => {
        const search:IAiTask = {
            language:tn.getLanguage()?tn.getLanguage():"EN",
            promptOne:this.state.schoolName,
            promptTwo:this.state.schoolLocation,
            promptThree:this.state.country,
            taskType:AI_TASK_TYPE.SCHOOL_VACATIONS,
            accountIds:getSubmittedSchoolVacationAccountIds(this.props.family, this.state.accountIds),
          }
      
        this.props.aiTask(search);
        const ct:CountryType|undefined = getHolidayCountryForSchoolVacation(this.state.country);

        if (ct !== undefined) {
            this.props.setCountry(ct);
        }
        
        this.props.setRegion(this.state.schoolLocation);

        this.props.nextStep();
    }

    private toggleAccountId = (accountId:number) => {
        this.setState((state) => ({
            accountIds:state.accountIds.includes(accountId)
                ? state.accountIds.filter((id) => id !== accountId)
                : [...state.accountIds, accountId],
        }));
    };
}

function mapStateToProps(state: any) {
    const navigatorLanguage = navigator.language || navigator.languages[0];
    const parts = navigatorLanguage.split(/[-_]/);
    const selectedCountry = normalizeSchoolVacationCountry(parts.length > 1 ? parts[1] : "us");

    return {
        family: state.family.family,
        familyData: state.family.familyData,
        user: state.user.session.data,
        selectedCountry,
    };
}


const mapDispatchToProps = {
    aiTask: EventActions.aiTask,
    setCountry: UserActions.saveHolidayRegion,
};

ImportHolidays.contextType = cordovaContext;

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(ImportHolidaysStyles)(ImportHolidays));



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepImportHolidays/importHolidaysAI.component.tsx